module.exports = __webpack_public_path__ + "img/icn_cold_disable.dcc7b817.svg";